import { render, staticRenderFns } from "./View.vue?vue&type=template&id=039ef544"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "@/styles/inner/view.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./View.vue?vue&type=style&index=1&id=039ef544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports